module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "El valor debe ser ".concat(args.maxValue, " o anterior.");
  },
  "rangeReversed": "La fecha de inicio debe ser anterior a la fecha de finalizaci\xF3n.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "El valor debe ser ".concat(args.minValue, " o posterior.");
  },
  "unavailableDate": "Fecha seleccionada no disponible."
};